var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-slide-y-reverse-transition', [_vm.show ? _c('div', {
    staticClass: "objects-popup-wrapper"
  }, [_c('div', {
    staticClass: "objects-wrapper"
  }, [_c('div', {
    staticClass: "closeBtn pointer noselect",
    on: {
      "click": _vm.hideApplication
    }
  }, [_vm._v(" zatvoriť "), _c('img', {
    staticClass: "activate-button nav-link-icon filter-primary MGleft10px",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    }
  })]), _vm._l(_vm.objects, function (object, index) {
    return _c(_vm.objectsComponent, {
      key: index,
      tag: "component",
      staticClass: "w-inline-block no-decoration position-relative",
      attrs: {
        "object": object
      },
      on: {
        "restore": function restore($event) {
          return _vm.$emit('restore', $event);
        }
      }
    });
  })], 2)]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }